import Component from '../core/Component'
import { substitute } from '../utils/String'
import { loadComponents } from '../core/componentUtils'
import { scrollToElement } from '../services/Scroll'
import throttle from 'lodash/throttle'

export const EMITS =  {
    ITEM_HOVER: 'item-hover',
    UNHOVER: 'unhover',
}

export default class MapickList extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            itemTemplate: '',
            ...options
        })

        this.lastHoverItem = null
    }

    get items() {
        return [...this.element.children]
    }

    prepare() {
        if (!this.options.itemTemplate) {
            console.error('Neni definovana template pro vyrenderovani itemu')
        }

        this.element.addEventListener('mouseover', this.handleMouseOver)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
    }

    handleMouseLeave = () => {
        this.lastHoverItem = null
        this.emit(EMITS.UNHOVER)
    }

    handleMouseOver = throttle((event) => {
        const element = event.target.closest('[data-point-id]')
        if (element && element !== this.lastHoverItem) {
            this.emit(EMITS.ITEM_HOVER, {
                pointId: element.dataset.pointId
            })
            this.lastHoverItem = element
        }
        if (!element && this.lastHoverItem) {
            this.emit(EMITS.UNHOVER)
            this.lastHoverItem = null
        }
    },100)

    scrollToItem(point) {
        const element = point.__listItemEl
        if (!element) {
            return
        }

        scrollToElement(element, {
            mode: 'auto'
        })
    }

    isPointHighlightedItem(point) {
        const element = point.__listItemEl
        if (!element) {
            return
        }
        return
    }

    getItemState(point, stateName) {
        const element = point.__listItemEl
        if (!element) {
            return false
        }
        return element.getAttribute(`data-${stateName}`)
    }

    setItemState(point, stateName, stateValue) {
        const element = point.__listItemEl
        if (!element) {
            return
        }

        element.setAttribute(`data-${stateName}`, stateValue)
    }

    show(points) {
        this.clear()

        const createListItemEl = point => {
            const buffer = document.createElement('div')
            buffer.innerHTML = substitute(this.options.itemTemplate, {
                ...point,
                comprehensiveConsultancyHTML: point.comprehensiveConsultancy ? `<span class="Tag Tag--orange Tag--topLeftAbsolute" data-tooltip-content="V tomto poradenském místě působí certifikovaný poradce v komplexním finančním poradenství, s odbornými znalostmi v široké produktové nabídce skupiny Raiffeisen a partnerů."><span class="Tag-label">Komplexní poradenství</span></span>` : ``,
                timeChangeHTML: point.timeChanges.map(timeChange => `
                    <div class="TimeChange TimeChange--${timeChange.color} mt-5">
                        <strong>Změna otevírací doby:</strong>
                        ${timeChange.text} 
                        ${timeChange.tooltipText ? `<span class="Icon Icon--info" data-tooltip-content="${timeChange.tooltipText}" aria-hidden="true"></span>` : ``}
                    </div>
                `).join(''),
            })
            point.__listItemEl = buffer.firstChild
            loadComponents(point.__listItemEl)
            point.__listItemEl.setAttribute('data-point-id', point.id)
            return point.__listItemEl
        }

        if (points.length) {
            points.forEach((point, index) => {
                let el = point.__listItemEl || createListItemEl(point)

                if (el.parentNode !== this.element) {
                    this.element.insertBefore(el, this.element.children[index]?.nextSibling)
                }
            })
        } else {
            this.element.innerHTML = 'Zadne vysledky'
        }
    }

    clear() {
        this.element.innerHTML = ''
    }
}
